// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".treeContainer--2Yh_xIDY {\n  min-height: 695px;\n  padding: 20px 30px;\n  border: 1px solid var(--editor-brick-stroke-color);\n  border-radius: var(--editor-brick-border-radius);\n}\n  .treeContainer--2Yh_xIDY .item--3ArGjXqy {\n    height: 15px;\n    width: 80px;\n    margin-bottom: 10px;\n    background: var(--editor-brick-skeleton-bg-light);\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"treeContainer": "treeContainer--2Yh_xIDY",
	"item": "item--3ArGjXqy"
};
export default ___CSS_LOADER_EXPORT___;
